import { render, staticRenderFns } from "./FeedbackBanner.vue?vue&type=template&id=07f05c71"
import script from "./FeedbackBanner.vue?vue&type=script&lang=js"
export * from "./FeedbackBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports